export default function PHP_crypt() {
  return (
    <div>
      <h1>PHP_crypt</h1>
    </div>
  );
}
